<template>
  <div>
    <h1 style="text-align: center;">Featured Component Editor</h1>
    <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
    <div>
      <b-card>
      <b-table outlined hover :fields="fields" :items="data">

        <template #cell(FeaturedCheck)="data">
          <FeaturedCheck :ContentId="data.item.ID" v-on:setData="setData" :Featured="data.item.Featured"/>
        </template>
      </b-table>
      </b-card>
    </div>
    <div>
      <button @click="submitThis()" class="submit-btn">Set Featured Content</button>
    </div>
  </div>
</template>

<script>
import {ajaxGet} from "@/ajax";
import FeaturedCheck from "@/Editors/Create/FeaturedCheck";
import {apiUrl} from "@/main";
export default {
  name: "Featured",
  components: {FeaturedCheck},
  props:["token"],
  data: function() {
    return  {
      fields: [
        { key: "ID", label: this.$t("ID"),thClass: 'd-none', tdClass: 'd-none'},
        { key: "Featured", label: "",thClass: 'd-none', tdClass: 'd-none'},
        { key: "Title", label: this.Title},
        { key: "ContentType", label: this.$t("ContentType")},
        { key: "FeaturedCheck", label: ""}
      ],
    
      isLoading: false,
      data:[],
      form: {
        Name: "",
      },
    };
  },
  mounted: function() {
    let featuredComp = this;
    
    setTimeout(function() {
      ajaxGet(apiUrl() + "/content/allcontent",
          featuredComp.dataSuccessLoad,
          featuredComp.dataError,
          localStorage.token
      );
    }, 50);
    
  },
  methods: {
    dataSuccessLoad: function(res) {
      this.data = res;
      this.loading = false;
    },
    dataError: function(status = 0) {
      if (status == 401) {
       this.$emit("logout");
       this.$router.push("/");
      }

      this.loading = false;
    },
    setData : function(token) {
      this.$emit('setData', token);
    },
   submitThis(){
     this.$router.push("/editors/component/Featured");
   }
    
  }
}
</script>

<style scoped>
.submit-btn{
  width: 100%;
  height: 2em;
  font-size: 1.5em;
  font-weight: 800;
  margin-top: 0.5em;
}
.has-error{
  border: red 5px solid;
  box-sizing: border-box;
}
.has-error::after{
  content: "Missing content/invalid content.";
  color: red;
  background: white;
  font-weight: 800;
}
.loading{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  justify-content: center;
  text-align: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  font-size: 4em;
  font-weight: 900;
}
</style>